import { useState, useEffect } from 'react';
import axios from 'axios';
import NotificationElement from './NotificationElement';
import { getToken } from '../utils';
import { toast } from 'react-toastify';

const smsDataOn = {
  notification_type_id: 1,
  status: 1,
};
const smsDataOff = {
  notification_type_id: 1,
  status: 0,
};

const emailDataOn = {
  notification_type_id: 2,
  status: 1,
};
const emailDataOff = {
  notification_type_id: 2,
  status: 0,
};
const inAppDataOn = {
  notification_type_id: 2,
  status: 1,
};
const inAppDataOff = {
  notification_type_id: 2,
  status: 0,
};

function Notifications() {
  const [trackClickedToggleButton, setTrackClickedToggleButton] =
    useState(null);
  const [notification, setnotification] = useState();
  const [toggleSms, setToggleSms] = useState('');
  const [toggleEmail, setToggleEmail] = useState('');
  const [toggleInApp, setToggleInApp] = useState('');

  const { token: userToken } = getToken();

  const userId = getToken()?.user?.id;

  const handleChangeSms = (e) => {
    setTrackClickedToggleButton(1);
    setToggleSms(e.target.checked);
  };
  const handleChangeEmail = (e) => {
    setToggleEmail(e.target.checked);
    setTrackClickedToggleButton(2);
  };
  const handleChangeInApp = (e) => {
    setToggleInApp(e.target.checked);
    setTrackClickedToggleButton(3);
  };

  useEffect(() => {
    const notifictionSetting = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/notifications/user`,
          { user_id: userId },
          {
            headers: { Authorization: `Bearer ${userToken}` },
          }
        );
        setnotification(response.data);
      } catch (error) {
        console.log(error);
      }
    };
    notifictionSetting();
  }, [userToken, userId]);

  const smsId = notification?.find((data) => {
    return data?.notification_type?.id === 1;
  });

  const emailId = notification?.find((data) => {
    return data?.notification_type?.id === 2;
  });
  const inAppId = notification?.find((data) => {
    return data?.notification_type?.id === 3;
  });

  useEffect(() => {
    setToggleSms(smsId?.status === '1');
    setToggleEmail(emailId?.status === '1');
    setToggleInApp(inAppId?.status === '1');
  }, [smsId, emailId, inAppId]);

  useEffect(() => {
    const dataS = toggleSms ? smsDataOn : !toggleSms ? smsDataOff : null;
    const dataE = toggleEmail
      ? emailDataOn
      : !toggleEmail
      ? emailDataOff
      : null;

    const dataI = toggleInApp
      ? inAppDataOn
      : !toggleInApp
      ? inAppDataOff
      : null;

    const data =
      trackClickedToggleButton === 1
        ? dataS
        : trackClickedToggleButton === 2
        ? dataE
        : trackClickedToggleButton === 3
        ? dataI
        : null;

    const setSettingsToggle = async () => {
      if (!data) {
        return;
      }
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/notifications/toggle-settings`,
          data,
          {
            headers: { Authorization: `Bearer ${userToken}` },
          }
        );

        toast.success(response.data.message, {
          autoClose: 500,
        });
      } catch (error) {
        toast.error(error.message);
      }
    };
    setSettingsToggle();
  }, [
    userToken,
    toggleSms,
    toggleEmail,
    toggleInApp,
    trackClickedToggleButton,
  ]);

  return (
    <div>
      <NotificationElement
        content={{
          toggleSms,
          toggleEmail,
          toggleInApp,
          handleChangeSms,
          handleChangeEmail,
          handleChangeInApp,
        }}
      />
    </div>
  );
}

export default Notifications;
